export const CODE_SYMMETRY = 'symmetry';
export const CODE_FIRE = 'fire';
export const CODE_SCINTILLATION = 'scintillation';
export const CODE_INTEGRAL = 'integral';
export const CODE_INTEGRAL_V2 = 'integralV2';
export const CODE_INTEGRAL_NORM = 'integralNorm';
export const CODE_SPREAD = 'spread';
export const CODE_FLUOR = 'fluor';
export const CODE_BRILLIANCE = 'brilliance';
export const CODE_COLOR = 'color';
export const CODE_DEAD_ZONES = 'deadzones';
export const CODE_PAVILLION_COLOR_VIBOX = 'pavcolorvibox';
